import type { ICellRendererComp, ICellRendererParams } from "ag-grid-enterprise";
import { formatVoteBoxCountLabel } from "../export_utils";

interface ElectionNameCellRendererParams extends ICellRendererParams {
  linkOut?: boolean;
}

export class ElectionNameCellRenderer implements ICellRendererComp {
  private eGui!: HTMLElement;

  init(params: ElectionNameCellRendererParams): void {
    this.eGui = document.createElement("div");

    if (params.node.group) {
      this.eGui.textContent = params.value ?? "";
      return;
    }

    if (params.node.rowPinned) {
      const pinnedData = (params.data ?? {}) as Record<string, unknown>;
      this.eGui.textContent = (pinnedData.footer_label as string | undefined) ?? "";
      return;
    }

    const data = (params.data ?? {}) as Record<string, unknown>;

    if (data.row_type === 1) {
      this.renderVoteBox(data, params.linkOut ?? true);
      return;
    }

    this.renderElection(params, data);
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  refresh(): boolean {
    return false;
  }

  private renderElection(params: ICellRendererParams, data: Record<string, unknown>): void {
    const id = data.id as string | number | undefined | null;
    const typeLabel = (data.type_label as string | undefined) ?? "";
    const linkUrl = data.link_url as string | undefined | null;

    this.eGui.className = "root-ag-election-name-cell";

    const name = document.createElement(linkUrl ? "a" : "span");
    name.className = "root-ag-election-name-cell__name";
    name.textContent = params.value ?? "";
    if (linkUrl) {
      (name as HTMLAnchorElement).href = linkUrl;
    }
    this.eGui.appendChild(name);

    const metaRow = document.createElement("span");
    metaRow.className = "root-ag-election-name-cell__meta";

    if (typeLabel) {
      const typeEl = document.createElement("span");
      typeEl.className = "root-ag-election-name-cell__type";
      typeEl.textContent = typeLabel;
      metaRow.appendChild(typeEl);
    }

    if (id !== undefined && id !== null) {
      const idEl = document.createElement("span");
      idEl.className = "root-ag-election-name-cell__id";
      idEl.textContent = `${id}`;
      metaRow.appendChild(idEl);
    }

    this.eGui.appendChild(metaRow);
  }

  private renderVoteBox(data: Record<string, unknown>, linkOut: boolean): void {
    const entityId = data.entity_id as string | number | undefined | null;
    const name = (data.name as string | undefined) ?? "";
    const childCount = data.childCount as number | undefined;

    this.eGui.className = "root-ag-election-name-cell root-ag-election-name-cell--vote-box";

    const titleEl = document.createElement(linkOut ? "a" : "span");
    titleEl.className = "root-ag-election-name-cell__name";
    titleEl.textContent = name;
    if (linkOut && entityId !== undefined && entityId !== null) {
      (titleEl as HTMLAnchorElement).href = `/vote_boxes/${entityId}/dashboard`;
    }
    this.eGui.appendChild(titleEl);

    const metaRow = document.createElement("span");
    metaRow.className = "root-ag-election-name-cell__meta";

    if (childCount !== undefined && childCount !== null) {
      const countEl = document.createElement("span");
      countEl.className = "root-ag-election-name-cell__box-count";
      countEl.textContent = formatVoteBoxCountLabel(childCount);
      metaRow.appendChild(countEl);
    }

    if (entityId !== undefined && entityId !== null) {
      const idEl = document.createElement("span");
      idEl.className = "root-ag-election-name-cell__id";
      idEl.textContent = `${entityId}`;
      metaRow.appendChild(idEl);
    }

    this.eGui.appendChild(metaRow);
  }
}
